import { updateLineItemsOnUpdateHelper, addLineItemErrorHelper,
getNewLineItem, updateLineItemsOnCreateHelper } from '../utils/lineItemUtils';

const initialState = {
  loading: false,
  items: [],
  vendorTypes: [],
  filters: {
    query: null,
    vendor: '',
  },
  errors: {},
};

// include filters or not?
const newState = (state, items) => (
  {
    ...state,
    items,
    loading: false,
    filters: {
      query: null,
    },
  }
);

const addBlankLineItemToPhase = (state, items) => {
  items.push(getNewLineItem());
  return newState(state, items);
};

const updateStateLineItemsOnCreate = (state, payload) => {
  const items = [...state.items];
  updateLineItemsOnCreateHelper(items, payload);
  return newState(state, items);
};

const updateStateLineItemsOnUpdate = (state, payload) => {
  const items = [...state.items];
  updateLineItemsOnUpdateHelper(items, payload);
  return newState(state, items);
};

const addLineItemError = (state, payload) => {
  const items = [...state.items];
  addLineItemErrorHelper(items, payload);
  return newState(state, items);
};

const lineItems = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'FETCH_VENDOR_TYPES_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'FETCH_VENDOR_TYPES_SUCCESS':
      return {
        ...state,
        loading: false,
        vendorTypes: payload,
      };
    case 'FETCH_VENDOR_TYPES_FAILURE':
      return {
        ...state,
        loading: false,
        errors: payload.errors,
      };
    case 'LINE_ITEMS_SUCCESS':
      return addBlankLineItemToPhase(state, payload.line_items);
    case 'CREATE_LINE_ITEM_SUCCESS':
      return updateStateLineItemsOnCreate(state, payload);
    case 'CREATE_LINE_ITEM_FAILURE':
    case 'UPDATE_LINE_ITEM_FAILURE':
      return addLineItemError(state, payload);
    case 'UPDATE_LINE_ITEM_SUCCESS':
      return updateStateLineItemsOnUpdate(state, payload);
    case 'LINE_ITEMS_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'LINE_ITEMS_FAILURE':
      return {
        ...state,
        errors: payload.errors || {},
        loading: false,
      };
    case 'LINE_ITEMS_SET_FILTERS':
      return {
        ...state,
        filters: payload,
      };
    default:
      return state;
  }
};

export default lineItems;

export const getVendorTypes = state => state.lineItems.vendorTypes;



// WEBPACK FOOTER //
// ./client/app/reducers/line_items.js